var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-qr"},[_c('img',{staticClass:"btn-qr-mask",attrs:{"srcSet":_vm.utility.getImgSrcSet('thai-qr-mask')}}),_c('img',{staticClass:"btn-qr-search",attrs:{"srcSet":_vm.utility.getImgSrcSet('qr-search')}})])}
var staticRenderFns = []

export { render, staticRenderFns }